module.exports = __webpack_public_path__ + "static/media/cpanel.b6a04963.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/cpanel.svg
// module id = 265
// module chunks = 0